import React from "react";
import { Tag, Globe2 } from "lucide-react";
import { SEO } from "../components/SEO";
import { PageHero } from "../components/PageHero";
import { Reveal } from "../components/Reveal";
import { LeadForm } from "../components/forms/LeadForm";
import { useLang } from "../i18n/LanguageContext";

const ModelBlock = ({ icon: Icon, title, desc, steps, testId }) => (
  <div className="bg-white border border-black/8 p-10 md:p-12 h-full" data-testid={testId}>
    <Icon size={26} strokeWidth={1.5} className="text-[#19C7C1]" />
    <h2 className="mt-6 text-2xl md:text-3xl font-light tracking-tight text-[#061A26]">{title}</h2>
    <p className="mt-4 text-base text-slate-600 leading-relaxed">{desc}</p>
    <ol className="mt-8 space-y-4">
      {steps.map((s, i) => (
        <li key={s} className="flex items-center gap-4 text-sm text-[#061A26]">
          <span className="text-xs font-semibold text-[#19C7C1] tracking-widest tabular-nums w-6">{String(i + 1).padStart(2, "0")}</span>
          <span className="flex-1 border-b border-black/5 pb-4">{s}</span>
        </li>
      ))}
    </ol>
  </div>
);

export default function PartnershipPage() {
  const { t } = useLang();
  return (
    <>
      <SEO page="partnership" />
      <PageHero eyebrow={t.partnership.eyebrow} title={t.partnership.title} sub={t.partnership.sub} testId="partnership-hero" />

      <section className="bg-[#F7F8F5] py-20 md:py-28">
        <div className="max-w-[1320px] mx-auto px-6 md:px-10 grid grid-cols-1 lg:grid-cols-2 gap-6">
          <Reveal>
            <ModelBlock icon={Tag} title={t.partnership.plTitle} desc={t.partnership.plDesc} steps={t.partnership.plSteps} testId="private-label-block" />
          </Reveal>
          <Reveal delay={0.15}>
            <ModelBlock icon={Globe2} title={t.partnership.distTitle} desc={t.partnership.distDesc} steps={t.partnership.distSteps} testId="distribution-block" />
          </Reveal>
        </div>
      </section>

      <section className="bg-white py-24 md:py-32 border-t border-black/5" id="inquiry">
        <div className="max-w-[860px] mx-auto px-6 md:px-10">
          <Reveal>
            <div className="w-14 h-px bg-[#19C7C1] mb-8" />
            <h2 className="text-2xl md:text-3xl font-light tracking-tight text-[#061A26]">{t.partnership.formTitle}</h2>
            <p className="mt-4 text-base text-slate-600">{t.partnership.formSub}</p>
          </Reveal>
          <Reveal delay={0.15} className="mt-12">
            <LeadForm variant="partnership" />
          </Reveal>
        </div>
      </section>
    </>
  );
}
